import { Calendar } from "./Calendar";
import "./index.css";

export function App() {
  return (
    <Calendar />
  );
}

export default App;
